<template>
  <div v-if="rowID !== '0'">
    <div v-if="loading" style="min-height: 200px;" class="d-flex flex-row align-center">
      <v-progress-linear indeterminate></v-progress-linear>
    </div>
    <div class="blocks" v-else>
      <div class="blocks__headerDiv" style="display: flex; flex-direction: row"
           :style="!blockOpened ? 'border-bottom: none' : ''" @click="blockOpened = !blockOpened">
        <p class="headerText">
          Блок 2. Информация о публичном представлении результатов научно-исследовательской работы
        </p>
        <img
          v-if="blockOpened"
          src="@/assets/icons/block_opened_blue.svg" class="btn_open" alt="">
        <img
          v-else
          src="@/assets/icons/block_closed_blue.svg" class="btn_open" alt="">
      </div>
      <div v-if="blockOpened && block2Data.length > 0">
        <Block2Item
          v-for="(item, j) in block2Data" :key="j"
          :value.sync="item"
          :rowID="rowID"
          :order="j"
          :konvertConvert="konvertConvert"
          :applicantBlocked="applicantBlocked"
          :eventAreaArray="eventAreaArray"
          :eventStatusArray="eventStatusArray"
          :eventTypeArray="eventTypeArray"
          :eventMonthsArray="eventMonthsArray"
          @updateData="getAllBlock2"
        />
      </div>
      <Block2Creation
        v-if="blockOpened && blockEditingInProcess && !applicantBlocked"
        :applicantBlocked="applicantBlocked"
        :rowID="rowID"
        @updateData="getAllBlock2"
      />
      <div class="btnDiv" v-if="blockOpened && block2Data.length > 0">
        <button v-if="applicantBlocked || isExpert" class="usual-btn usual-btn_disabled">Добавить</button>
        <button v-else class="usual-btn" @click="addRow">Добавить</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import Block2Item from "@/components/applicants/applicantForm/mnsBlocks/blockItems/Block2Item";
import Block2Creation from "@/components/applicants/applicantForm/mnsBlocks/blockCreation/Block2Creation";

export default {
  name: "Block2",
  components: {Block2Creation, Block2Item},
  data() {
    return {
      loading: false,
      blockOpened: false,
      blockEditingInProcess: true,
      block2Data: [],
      eventMonthsArray: [],
      eventTypeArray: [],
      eventStatusArray: [],
      eventAreaArray: [],
    }
  },
  props: {
    rowID: {
      type: String,
      default: ''
    },
    applicantBlocked: {
      type: Boolean,
      default: false,
    },
    konvertConvert: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters('keycloak', {
      getAuthData: 'getAuthData',
      isExpert: 'isExpert',
      // isCurator: 'isCurator',
    }),
  },
  created() {
    if (this.rowID !== '0') {
      this.getAllBlock2();
      this.getSprArea();
      this.getSprEventType();
      this.getSprEventStatus();
      this.getSprMonths();
    }
    
    if (this.isExpert) {
      this.blockOpened = true;
    }
  },
  methods: {
    async getAllBlock2() {
      this.loading = true;
      this.block2Data = [];
      try {
        const res = await axios.get(`/api/2022/mns/block4/get?mnsId=${this.rowID}`, {headers: {Authorization: `Bearer   ${this.getAuthData.token}`}})
        if (res.status === 200 && res.data) {
          if (res.data.length > 0) {
            this.block2Data = res.data;
            this.blockEditingInProcess = false;
          } else {
            this.blockEditingInProcess = true;
          }
          console.log('getAllBlock2 успех');
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    
    async getSprArea() {
      this.eventAreaArray = [];
      try {
        const res = await axios.get(`/api/2022/spr/textValMns/get?block=4&position=1`, {headers: {Authorization: `Bearer   ${this.getAuthData.token}`}})
        if (res.status === 200 && res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.eventAreaArray.push({
              text: res.data[i].value,
              value: res.data[i].id
            })
          }
          console.log('getSprArea успех');
        }
      } catch (e) {
        console.log(e);
      }
    },
    
    async getSprEventType() {
      this.eventTypeArray = [];
      try {
        const res = await axios.get(`/api/2022/spr/textValMns/get?block=4&position=2`, {headers: {Authorization: `Bearer   ${this.getAuthData.token}`}})
        if (res.status === 200 && res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.eventTypeArray.push({
              text: res.data[i].value,
              value: res.data[i].id
            })
          }
          console.log('getSprEventType успех');
        }
      } catch (e) {
        console.log(e);
      }
    },
    
    async getSprEventStatus() {
      this.eventStatusArray = [];
      // this.creationData.articlePubStatus = null;
      try {
        const res = await axios.get(`/api/2022/spr/textValMns/get?block=4&position=4`, {headers: {Authorization: `Bearer   ${this.getAuthData.token}`}})
        if (res.status === 200 && res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.eventStatusArray.push({
              text: res.data[i].value,
              value: res.data[i].id
            })
          }
          console.log('getSprEventStatus успех');
        }
      } catch (e) {
        console.log(e);
      }
    },
    
    async getSprMonths() {
      this.eventMonthsArray = [];
      try {
        const res = await axios.get(`/api/2022/spr/textValMns/get?block=4&position=0`, {headers: {Authorization: `Bearer   ${this.getAuthData.token}`}})
        if (res.status === 200 && res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.eventMonthsArray.push({
              text: res.data[i].value,
              value: res.data[i].id
            })
          }
          console.log('getSprMonths успех');
        }
      } catch (e) {
        console.log(e);
      }
    },
    
    addRow() {
      this.blockEditingInProcess = true
    },
  }
}
</script>

<style lang="scss" scoped>

</style>